import React from "react";

export const SaveIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={width} height={height}>
			<path d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z" />
		</svg>
	);
};

export const TrashIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={width} height={height}>
			<path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" />
		</svg>
	);
};

export const PrintIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-printer-fill"
			viewBox="0 0 16 16"
		>
			<path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
			<path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
		</svg>
	);
};

export const JournalsIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-journals"
			viewBox="0 0 16 16"
		>
			<path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z" />
			<path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0z" />
		</svg>
	);
};

export const CodeIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width={width} height={height}>
			<path d="M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z" />
		</svg>
	);
};

export const ViewIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-view-list"
			viewBox="0 0 16 16"
		>
			<path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z" />
		</svg>
	);
};

export const TogglesIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-toggles"
			viewBox="0 0 16 16"
		>
			<path d="M4.5 9a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7h-7zm7 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-7-14a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm2.45 0A3.49 3.49 0 0 1 8 3.5 3.49 3.49 0 0 1 6.95 6h4.55a2.5 2.5 0 0 0 0-5H6.95zM4.5 0h7a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7z" />
		</svg>
	);
};

export const WarningIcon = ({ width = 16, height = 16, color = "#ca8a04" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-exclamation-triangle-fill"
			viewBox="0 0 16 16"
		>
			<path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
		</svg>
	);
};

export const ClipboardPlusIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-clipboard-plus"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"
			/>
			<path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
			<path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
		</svg>
	);
};

export const MailIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			aria-hidden="true"
			focusable="false"
			data-prefix="far"
			data-icon="envelope"
			width={width}
			height={height}
			className="svg-inline--fa fa-envelope"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
		>
			<path d="M448 64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V128C512 92.65 483.3 64 448 64zM64 112h384c8.822 0 16 7.178 16 16v22.16l-166.8 138.1c-23.19 19.28-59.34 19.27-82.47 .0156L48 150.2V128C48 119.2 55.18 112 64 112zM448 400H64c-8.822 0-16-7.178-16-16V212.7l136.1 113.4C204.3 342.8 229.8 352 256 352s51.75-9.188 71.97-25.98L464 212.7V384C464 392.8 456.8 400 448 400z" />
		</svg>
	);
};

export const PersonIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			aria-hidden="true"
			focusable="false"
			data-prefix="far"
			data-icon="user"
			className="svg-inline--fa fa-user"
			width={width}
			height={height}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
		>
			<path d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z" />
		</svg>
	);
};

export const NotificationIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			aria-hidden="true"
			focusable="false"
			data-prefix="far"
			data-icon="bell"
			className="svg-inline--fa fa-bell"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
			width={width}
			height={height}
		>
			<path d="M256 32V49.88C328.5 61.39 384 124.2 384 200V233.4C384 278.8 399.5 322.9 427.8 358.4L442.7 377C448.5 384.2 449.6 394.1 445.6 402.4C441.6 410.7 433.2 416 424 416H24C14.77 416 6.365 410.7 2.369 402.4C-1.628 394.1-.504 384.2 5.26 377L20.17 358.4C48.54 322.9 64 278.8 64 233.4V200C64 124.2 119.5 61.39 192 49.88V32C192 14.33 206.3 0 224 0C241.7 0 256 14.33 256 32V32zM216 96C158.6 96 112 142.6 112 200V233.4C112 281.3 98.12 328 72.31 368H375.7C349.9 328 336 281.3 336 233.4V200C336 142.6 289.4 96 232 96H216zM288 448C288 464.1 281.3 481.3 269.3 493.3C257.3 505.3 240.1 512 224 512C207 512 190.7 505.3 178.7 493.3C166.7 481.3 160 464.1 160 448H288z" />
		</svg>
	);
};

export const FullScreenIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			aria-hidden="true"
			focusable="false"
			data-prefix="fad"
			data-icon="expand-alt"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
			width={width}
			height={height}
			className="svg-inline--fa fa-expand-alt fa-w-14 fa-3x"
		>
			<g className="fa-group">
				<path
					d="M0 456V344c0-21.38 25.8-32.09 40.92-17L72 360l92.69-92.69a16 16 0 0 1 22.62 0l25.38 25.38a16 16 0 0 1 0 22.62L120 408l32.92 31c15.12 15.12 4.41 41-17 41H24a24 24 0 0 1-24-24z"
					className="fa-secondary"
				/>
				<path
					d="M235.31 196.69L328 104l-32.92-31c-15.12-15.12-4.41-41 17-41h112A24 24 0 0 1 448 56v112c0 21.38-25.8 32.09-40.92 17L376 152l-92.69 92.69a16 16 0 0 1-22.62 0l-25.38-25.38a16 16 0 0 1 0-22.62z"
					className="fa-primary"
				/>
			</g>
		</svg>
	);
};

export const CloseIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-x"
			viewBox="0 0 16 16"
		>
			<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
		</svg>
	);
};

export const FolderIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-folder2-open"
			viewBox="0 0 16 16"
		>
			<path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z" />
		</svg>
	);
};

export const SettingsIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={height} width={width}>
			<path d="M495.9 166.6C499.2 175.2 496.4 184.9 489.6 191.2L446.3 230.6C447.4 238.9 448 247.4 448 256C448 264.6 447.4 273.1 446.3 281.4L489.6 320.8C496.4 327.1 499.2 336.8 495.9 345.4C491.5 357.3 486.2 368.8 480.2 379.7L475.5 387.8C468.9 398.8 461.5 409.2 453.4 419.1C447.4 426.2 437.7 428.7 428.9 425.9L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L316.7 490.7C314.7 499.7 307.7 506.1 298.5 508.5C284.7 510.8 270.5 512 255.1 512C241.5 512 227.3 510.8 213.5 508.5C204.3 506.1 197.3 499.7 195.3 490.7L182.8 433.6C167 427 152.2 418.4 138.8 408.1L83.14 425.9C74.3 428.7 64.55 426.2 58.63 419.1C50.52 409.2 43.12 398.8 36.52 387.8L31.84 379.7C25.77 368.8 20.49 357.3 16.06 345.4C12.82 336.8 15.55 327.1 22.41 320.8L65.67 281.4C64.57 273.1 64 264.6 64 256C64 247.4 64.57 238.9 65.67 230.6L22.41 191.2C15.55 184.9 12.82 175.3 16.06 166.6C20.49 154.7 25.78 143.2 31.84 132.3L36.51 124.2C43.12 113.2 50.52 102.8 58.63 92.95C64.55 85.8 74.3 83.32 83.14 86.14L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L195.3 21.33C197.3 12.25 204.3 5.04 213.5 3.51C227.3 1.201 241.5 0 256 0C270.5 0 284.7 1.201 298.5 3.51C307.7 5.04 314.7 12.25 316.7 21.33L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L428.9 86.14C437.7 83.32 447.4 85.8 453.4 92.95C461.5 102.8 468.9 113.2 475.5 124.2L480.2 132.3C486.2 143.2 491.5 154.7 495.9 166.6V166.6zM256 336C300.2 336 336 300.2 336 255.1C336 211.8 300.2 175.1 256 175.1C211.8 175.1 176 211.8 176 255.1C176 300.2 211.8 336 256 336z" />
		</svg>
	);
};

export const SettingsOutlineIcon = ({ width = 16, height = 16, color = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height={height}
			width={width}
			fill={color}
			className="bi bi-gear"
			viewBox="0 0 16 16"
		>
			<path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
			<path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
		</svg>
	);
};

export const Toggle = ({ label, checked, toggleChanged }) => {
	return (
		<div className="form-check form-switch">
			<input
				className="form-check-input"
				type="checkbox"
				role="switch"
				id="flexSwitchCheckDefault"
				checked={checked}
				onChange={toggleChanged}
			/>
			<label className="form-check-label" htmlFor="flexSwitchCheckDefault">
				{label}
			</label>
		</div>
	);
};

export const FileIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-file-earmark"
			viewBox="0 0 16 16"
		>
			<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
		</svg>
	);
};

export const ErrorIcon = ({ width = 16, height = 16, color = "#dc3545" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
			width={width}
			height={height}
			className="bi bi-exclamation-circle-fill"
			viewBox="0 0 16 16"
		>
			<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
		</svg>
	);
};

export const EditIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-pencil"
			viewBox="0 0 16 16"
		>
			<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
		</svg>
	);
};

export const PlusIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
			width={width}
			height={height}
			className="bi bi-plus"
			viewBox="0 0 16 16"
		>
			<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
		</svg>
	);
};

export const MinusIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
			width={width}
			height={height}
			className="bi bi-dash"
			viewBox="0 0 16 16"
		>
			<path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
		</svg>
	);
};

export const PlusSlashMinusIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
			width={width}
			height={height}
			className="bi bi-plus-slash-minus"
			viewBox="0 0 16 16"
		>
			<path d="m1.854 14.854 13-13a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708ZM4 1a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 4 1Zm5 11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 9 12Z" />
		</svg>
	);
};

export const SuggestionIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill={color} height={height} width={width} viewBox="0 0 512 512">
			<path d="M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
		</svg>
	);
};

export const PlusSquareDottedIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-plus-square-dotted"
			viewBox="0 0 16 16"
		>
			<path d="M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834-1v1h.916v-1h-.916zm1.833 1h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
		</svg>
	);
};

export const CheckSquareIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-check2-square"
			viewBox="0 0 16 16"
		>
			<path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
			<path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
		</svg>
	);
};

export const EditSquareIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-pencil-square"
			viewBox="0 0 16 16"
		>
			<path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
			<path
				fillRule="evenodd"
				d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
			/>
		</svg>
	);
};

export const ArchiveIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-archive"
			viewBox="0 0 16 16"
		>
			<path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
		</svg>
	);
};

export const BoxIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-box2"
			viewBox="0 0 16 16"
		>
			<path d="M2.95.4a1 1 0 0 1 .8-.4h8.5a1 1 0 0 1 .8.4l2.85 3.8a.5.5 0 0 1 .1.3V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4.5a.5.5 0 0 1 .1-.3L2.95.4ZM7.5 1H3.75L1.5 4h6V1Zm1 0v3h6l-2.25-3H8.5ZM15 5H1v10h14V5Z" />
		</svg>
	);
};

export const CubeIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-box2"
			viewBox="0 0 16 16"
		>
			<path d="M7.377.62c.244.112.489.222.732.334l1.75.795 2.118.962 1.837.835c.295.135.589.282.889.403l.013.005V3.38c-.243.112-.489.222-.732.334l-1.75.795-2.118.962-1.837.835c-.295.135-.598.26-.888.404l-.014.005h.337l-.72-.334-1.716-.793L3.19 4.62l-1.793-.83c-.292-.136-.58-.284-.88-.407l-.01-.005v.575l.72-.334 1.715-.793 2.089-.967c.598-.277 1.195-.554 1.794-.83.291-.135.593-.259.878-.407l.012-.005c.158-.074.21-.315.12-.457-.105-.163-.287-.198-.457-.12l-.72.333c-.572.266-1.144.529-1.715.794l-2.09.967-1.793.83c-.292.135-.594.259-.879.407l-.012.005c-.218.102-.218.475 0 .575.244.114.487.225.73.339l1.75.808 2.103.974 1.803.833c.273.127.545.255.82.379.132.06.237.048.36-.007a40.315 40.315 0 01.58-.263c.557-.254 1.114-.505 1.669-.759l2.102-.955 1.89-.859 1.031-.468.047-.022c.218-.098.218-.477 0-.575l-.732-.333-1.75-.796-2.118-.962C9.84 1.01 9.228.732 8.616.453 8.319.318 8.024.183 7.727.05L7.714.045c-.158-.072-.367-.05-.457.12-.076.145-.05.378.12.455zm7.34 11.423l-.731.334-1.75.795-2.118.962-1.837.835c-.295.135-.599.259-.889.404l-.013.005c.167.096.335.191.502.288V8.07c0-.35.015-.702 0-1.052v-.015l-.165.288.732-.333 1.75-.795 2.117-.962 1.838-.835c.295-.136.598-.259.888-.404l.013-.005c-.166-.097-.335-.192-.501-.288V11.265c0 .35-.008.702 0 1.052v.015c0 .175.153.342.333.333a.34.34 0 00.333-.333V4.735c0-.35.008-.702 0-1.052v-.015a.336.336 0 00-.165-.289c-.111-.065-.225-.05-.336 0-.244.112-.489.222-.732.334l-1.75.795-2.118.962-1.837.835c-.295.133-.6.257-.889.404l-.013.005c-.103.046-.165.18-.165.288V14.599c0 .35-.008.702 0 1.052v.015c0 .118.063.229.165.289.112.065.225.05.337 0 .243-.112.488-.222.732-.334l1.75-.795 2.117-.962 1.838-.835c.295-.134.6-.257.888-.404l.013-.005c.16-.071.21-.315.12-.457-.106-.165-.286-.196-.456-.12zm-7.003 3.335l-.72-.334-1.716-.793-2.089-.967-1.793-.83c-.292-.135-.58-.285-.879-.407l-.012-.005.165.288V4.733c0-.35.015-.702 0-1.052v-.015c-.166.097-.335.192-.501.289l.72.333c.572.265 1.143.528 1.715.794.697.321 1.392.643 2.09.967l1.793.83c.292.135.58.285.879.407l.011.005-.165-.289V14.6c0 .35-.008.702 0 1.052v.015c0 .175.154.342.334.334a.34.34 0 00.333-.334V8.07c0-.35.008-.702 0-1.052v-.015c0-.108-.062-.24-.165-.288l-.72-.334-1.716-.793L3.19 4.62l-1.793-.83c-.294-.136-.586-.274-.879-.407l-.012-.005c-.111-.052-.226-.065-.336 0a.336.336 0 00-.165.288V11.263c0 .35-.008.702 0 1.052v.015c0 .109.061.24.165.289l.72.333 1.715.794c.697.321 1.392.643 2.09.967l1.793.83c.293.135.585.273.879.407l.011.005c.159.073.367.05.457-.12.077-.147.048-.379-.12-.457z" />
		</svg>
	);
};

export const BinderIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg width={width} height={height} color={color} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
			<path d="M11.851.462a.539.309 0 00-.593-.054L9.551.856v-.57A.483.277 0 009.054 0c-.07 0-.117 0-.19.014L0 1.944h.023L0 11.537l3.436.422.357.04.262-.067 7.513-1.998a.714.41 0 00.403-.368l.023-8.9a.354.203 0 00-.143-.205zM8.984.34v.666l-5.24 1.386-.26-.027c.214-.082.331-.19.308-.3-.07-.176-.615-.27-1.232-.203-.403.04-.759.15-.925.272l-.57-.055zM3.437 11.592l-2.868-.34.023-8.874 2.869.34zm7.94-2.025c0 .014-.023.041-.048.041l-7.274 1.93.023-8.847 4.906-1.305.592-.15 1.825-.488z" />
		</svg>
	);
};

export const MenuButtonIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-list"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
			/>
		</svg>
	);
};

export const SaveButtonIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
			<path d="M224 256c-35.2 0-64 28.8-64 64c0 35.2 28.8 64 64 64c35.2 0 64-28.8 64-64C288 284.8 259.2 256 224 256zM433.1 129.1l-83.9-83.9C341.1 37.06 328.8 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 151.2 442.9 138.9 433.1 129.1zM128 80h144V160H128V80zM400 416c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16V96c0-8.838 7.164-16 16-16h16v104c0 13.25 10.75 24 24 24h192C309.3 208 320 197.3 320 184V83.88l78.25 78.25C399.4 163.2 400 164.8 400 166.3V416z" />
		</svg>
	);
};

export const FileUploadIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			className="bi bi-file-earmark-arrow-up"
			viewBox="0 0 16 16"
		>
			<path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z" />
			<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
		</svg>
	);
};

export const CalendarIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-calendar"
			viewBox="0 0 16 16"
		>
			<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
		</svg>
	);
};

export const LinkIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-link-45deg"
			viewBox="0 0 16 16"
		>
			<path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" />
			<path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" />
		</svg>
	);
};

export const FileTextIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-file-earmark-text"
			viewBox="0 0 16 16"
		>
			<path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
			<path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
		</svg>
	);
};

export const AsteriskIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-asterisk"
			viewBox="0 0 16 16"
		>
			<path d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z" />
		</svg>
	);
};

export const ClockRotateLeftIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
			<path d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z" />
		</svg>
	);
};

export const ClockRotateRightIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg viewBox="380.965 -6 512 512" width={width} height={height} fill={color}>
			<path
				d="M 455.965 431 L 421.965 465 C 406.865 480.1 380.965 469.4 380.965 448.1 L 380.965 338 C 380.965 324.7 391.665 314 404.965 314 L 515.065 314 C 536.465 314 547.165 339.9 532.065 355 L 501.265 385.8 C 535.965 420.5 583.965 442 636.965 442 C 742.965 442 828.965 356 828.965 250 C 828.965 144 742.965 58 636.965 58 C 596.165 58 558.365 70.7 527.265 92.4 C 512.765 102.5 492.865 99 482.665 84.5 C 472.465 70 476.065 50.1 490.565 39.9 C 532.165 11 582.665 -6 636.965 -6 C 778.365 -6 892.965 108.6 892.965 250 C 892.965 391.4 778.365 506 636.965 506 C 566.265 506 502.265 477.3 455.965 431 Z M 636.965 378 C 623.665 378 612.965 367.3 612.965 354 L 612.965 250 C 612.965 243.6 615.465 237.5 619.965 233 L 691.965 161 C 701.365 151.6 716.565 151.6 725.865 161 C 735.165 170.4 735.265 185.6 725.865 194.9 L 660.865 259.9 L 660.865 354 C 660.865 367.3 650.165 378 636.865 378 L 636.965 378 Z"
				transform="matrix(-1, 0, 0, -1, 1273.930054, 500)"
			></path>
		</svg>
	);
};
export const CodeSlashIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-code-slash"
			viewBox="0 0 16 16"
		>
			<path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z" />
		</svg>
	);
};

export const RegexIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-regex"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 1 1 .707.707Zm9.9-.707a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.314.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707ZM6 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-6.5a.5.5 0 0 0-1 0v2.117L8.257 5.57a.5.5 0 0 0-.514.858L9.528 7.5 7.743 8.571a.5.5 0 1 0 .514.858L10 8.383V10.5a.5.5 0 1 0 1 0V8.383l1.743 1.046a.5.5 0 0 0 .514-.858L11.472 7.5l1.785-1.071a.5.5 0 1 0-.514-.858L11 6.617V4.5Z"
			/>
		</svg>
	);
};

export const FormulaIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
			<path d="M0 0h24v24H0z" fill="none" />
			<path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z" />
		</svg>
	);
};

export const ListIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-list-task"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
			/>
			<path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" />
			<path
				fillRule="evenodd"
				d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"
			/>
		</svg>
	);
};

export const RichTextIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-file-earmark-richtext"
			viewBox="0 0 16 16"
		>
			<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
			<path d="M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm1.639-3.708 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V8.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8s1.54-1.274 1.639-1.208zM6.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z" />
		</svg>
	);
};

export const CheckboxIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-check2-square"
			viewBox="0 0 16 16"
		>
			<path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
			<path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
		</svg>
	);
};

export const LetterIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-type"
			viewBox="0 0 16 16"
		>
			<path d="m2.244 13.081.943-2.803H6.66l.944 2.803H8.86L5.54 3.75H4.322L1 13.081h1.244zm2.7-7.923L6.34 9.314H3.51l1.4-4.156h.034zm9.146 7.027h.035v.896h1.128V8.125c0-1.51-1.114-2.345-2.646-2.345-1.736 0-2.59.916-2.666 2.174h1.108c.068-.718.595-1.19 1.517-1.19.971 0 1.518.52 1.518 1.464v.731H12.19c-1.647.007-2.522.8-2.522 2.058 0 1.319.957 2.18 2.345 2.18 1.06 0 1.716-.43 2.078-1.011zm-1.763.035c-.752 0-1.456-.397-1.456-1.244 0-.65.424-1.115 1.408-1.115h1.805v.834c0 .896-.752 1.525-1.757 1.525z" />
		</svg>
	);
};

export const NumberIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			fill={color}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className="bi bi-123"
			viewBox="0 0 16 16"
		>
			<path d="M2.873 11.297V4.142H1.699L0 5.379v1.137l1.64-1.18h.06v5.961h1.174Zm3.213-5.09v-.063c0-.618.44-1.169 1.196-1.169.676 0 1.174.44 1.174 1.106 0 .624-.42 1.101-.807 1.526L4.99 10.553v.744h4.78v-.99H6.643v-.069L8.41 8.252c.65-.724 1.237-1.332 1.237-2.27C9.646 4.849 8.723 4 7.308 4c-1.573 0-2.36 1.064-2.36 2.15v.057h1.138Zm6.559 1.883h.786c.823 0 1.374.481 1.379 1.179.01.707-.55 1.216-1.421 1.21-.77-.005-1.326-.419-1.379-.953h-1.095c.042 1.053.938 1.918 2.464 1.918 1.478 0 2.642-.839 2.62-2.144-.02-1.143-.922-1.651-1.551-1.714v-.063c.535-.09 1.347-.66 1.326-1.678-.026-1.053-.933-1.855-2.359-1.845-1.5.005-2.317.88-2.348 1.898h1.116c.032-.498.498-.944 1.206-.944.703 0 1.206.435 1.206 1.07.005.64-.504 1.106-1.2 1.106h-.75v.96Z" />
		</svg>
	);
};

export const InfoIcon = ({ width = 16, height = 16, color = "black", style }) => {
	return (
		<svg
			className="w-6 h-6 mr-2"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke={color}
			width={width}
			height={height}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	);
};

export const SuccessIcon = ({ width = 16, height = 16, color = "black", style }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="w-6 h-6 mr-2"
			fill="none"
			viewBox="0 0 24 24"
			stroke={color}
			width={width}
			height={height}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
			/>
		</svg>
	);
};
export const OpenPointIcon = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-info-circle-fill"
			viewBox="0 0 16 16"
		>
			<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
		</svg>
	);
};

export const ToolboxIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-tools"
			viewBox="0 0 16 16"
		>
			<path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0Zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708ZM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11Z" />
		</svg>
	);
};

export const ReleaseIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 23 28.75"
			fill="none"
			x="0px"
			y="0px"
		>
			<path
				d="M15.8496 9.60759C15.0688 10.3886 13.8022 10.3886 13.0215 9.60759C12.2402 8.82646 12.2402 7.56023 13.0215 6.7791C13.8022 5.99809 15.0688 5.99809 15.8496 6.7791C16.6309 7.56023 16.6309 8.82646 15.8496 9.60759Z"
				transform="translate(0.36377 0.241699)"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.36523 15.2602L11.3755 19.2746C11.856 19.7559 12.5508 19.9648 13.1904 19.7334C14.2798 19.3394 15.8945 18.5455 16.3652 17.1945C16.4702 16.893 16.5322 16.6066 16.561 16.3373C16.5669 16.2834 16.5713 16.23 16.5742 16.1774C16.5811 16.0649 16.582 15.9556 16.5781 15.8495C16.5742 15.736 16.5645 15.6263 16.5503 15.5206C16.4028 14.4263 16.3623 13.0976 17.1426 12.3165L19.5083 9.94804C20.4624 8.99284 21.2241 7.85832 21.6421 6.57451C22.3208 4.48894 23.1343 1.33598 22.2119 0.41362C21.29 -0.508011 18.1421 0.303024 16.0566 0.981491C14.769 1.40044 13.6318 2.16508 12.6748 3.12309L10.3149 5.48564C9.53418 6.26738 8.2041 6.22746 7.10938 6.07878C6.86865 6.04607 6.60693 6.03728 6.32715 6.06413C6.04736 6.09099 5.74902 6.15337 5.43408 6.26311C4.08203 6.73418 3.28955 8.35136 2.89648 9.44182C2.66602 10.0812 2.875 10.7749 3.35596 11.2552L7.36523 15.2602ZM19.8638 2.07585C18.8657 2.2238 17.6816 2.55595 16.6753 2.88335C15.7412 3.1873 14.8667 3.75871 14.0898 4.53642L11.73 6.89897C10.9106 7.71904 9.89355 8.01628 9.07227 8.11638C8.25293 8.21635 7.44824 8.14311 6.84033 8.06059C6.6582 8.03581 6.4126 8.03996 6.09229 8.15166C5.9707 8.19389 5.73877 8.34282 5.44824 8.76091C5.38135 8.8571 5.31787 8.95879 5.25732 9.06413C5.10059 9.3372 4.96436 9.63457 4.85205 9.92278L8.77881 13.8451L12.7075 17.7784C13.1064 17.6221 13.5225 17.4213 13.8677 17.1812C14.0425 17.0596 14.1704 16.9482 14.2627 16.8508C14.3911 16.7155 14.4517 16.6072 14.4766 16.5363C14.5327 16.3747 14.562 16.2322 14.5737 16.1073C14.5854 15.9842 14.5806 15.8782 14.5684 15.7879C14.4863 15.1814 14.4136 14.3779 14.5132 13.5595C14.6128 12.7392 14.9092 11.7223 15.7275 10.903L18.0933 8.53459C18.8677 7.7592 19.437 6.88701 19.7402 5.95537C20.0679 4.9489 20.4009 3.76347 20.5493 2.76408C20.5942 2.46086 20.6172 2.20683 20.6235 2.00188C20.4194 2.00822 20.166 2.03105 19.8638 2.07585Z"
				transform="translate(0.36377 0.241699)"
				fill={color}
			/>
			<path
				d="M6.65723 15.9716C6.2666 15.581 5.63379 15.581 5.24316 15.9716L0.293457 20.9213C-0.097168 21.3118 -0.097168 21.945 0.293457 22.3355C0.684082 22.726 1.31689 22.726 1.70752 22.3355L6.65723 17.3858C7.04785 16.9953 7.04785 16.3621 6.65723 15.9716Z"
				transform="translate(0.36377 0.241699)"
				fill={color}
			/>
			<path
				d="M3.12158 13.8503C3.51221 13.4596 4.14502 13.4596 4.53564 13.8503C4.92627 14.2408 4.92627 14.8739 4.53564 15.2645L1.70752 18.0928C1.31689 18.4834 0.683594 18.4834 0.292969 18.0928C-0.0976562 17.7023 -0.0976562 17.0691 0.292969 16.6786L3.12158 13.8503Z"
				transform="translate(0.36377 0.241699)"
				fill={color}
			/>
			<path
				d="M8.77832 18.0929C8.3877 17.7023 7.75488 17.7023 7.36426 18.0929L4.53564 20.9213C4.14502 21.3118 4.14502 21.945 4.53564 22.3355C4.92627 22.7261 5.55957 22.7261 5.9502 22.3355L8.77832 19.5071C8.98145 19.3042 9.0791 19.0358 9.0708 18.7699C9.06348 18.5241 8.96582 18.2806 8.77832 18.0929Z"
				transform="translate(0.36377 0.241699)"
				fill={color}
			/>
		</svg>
	);
};

export const BriefcaseIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-briefcase"
			viewBox="0 0 16 16"
		>
			<path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
		</svg>
	);
};

export const FilterIcon = ({ width = 16, height = 16, style, className }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			style={style}
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			className={className}
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
			/>
		</svg>
	);
};

export const GlobeIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="white"
			viewBox="0 0 24 24"
			strokeWidth="1.5"
			stroke={color}
			className="w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
			/>
		</svg>
	);
};

export const BullhornIcon = ({ width = 16, height = 16, color = "black" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 512 512">
			<path d="M416 0c-7.125 0-14.19 2.375-19.97 7.031L311 75.06C268.3 109.2 214.7 128 160 128H64C28.66 128 0 156.7 0 192v96c0 35.34 28.66 64 64 64h96c54.66 0 108.3 18.81 150.1 52.94L396 472.1C400.8 476.8 409.8 480 416 480c24.91 0 32-22.78 32-32V32C448 23.25 441 0 416 0zM160 320H64c-17.64 0-32-14.36-32-32V192c0-17.64 14.36-32 32-32h96V320zM415.8 447.8L330.1 379.9C290.1 347.1 242.5 328.1 192 322.1V157.9c50.53-6.006 98.99-25.86 138.1-57.82l84.94-67.93c.0234 .0234-.0176 0 0 0c.0352 0-.0117 .0996 0 0l.1244 414.8C416 447.2 415.9 447.5 415.8 447.8zM191.7 383.5C191.4 374.7 184.3 368.2 175.2 368c-8.828 .2656-15.78 7.656-15.52 16.48c1.156 38 28.36 70.55 28.61 70.83c3.594 4.203 4.688 11.11 2.641 16.86C189.3 476.9 185.8 480 182.3 480H130.8C128.3 480 125.8 478.5 124 475.9c-1.188-1.672-29.05-41.7-27.97-91.58C96.22 375.5 89.22 368.2 80.38 368c-8.406-.25-16.16 6.828-16.34 15.66c-1.281 59.28 30.23 105.6 33.88 110.8C105.9 505.6 117.9 512 130.8 512h51.47c17.34 0 32.59-11.44 38.84-29.09c5.906-16.52 2.578-35.53-8.297-48.2C212.6 434.5 192.5 409.5 191.7 383.5zM496 192C487.2 192 480 199.2 480 208v64C480 280.8 487.2 288 496 288S512 280.8 512 272v-64C512 199.2 504.8 192 496 192z" />
		</svg>
	);
};

export const GraphUpArrow = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-graph-up-arrow"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
			/>
		</svg>
	);
};

export const Clock = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-clock"
			viewBox="0 0 16 16"
		>
			<path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
			<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
		</svg>
	);
};

export const ExclamationTriangle = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-exclamation-triangle"
			viewBox="0 0 16 16"
		>
			<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
			<path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
		</svg>
	);
};

export const FileEarmarkText = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-file-earmark-text"
			viewBox="0 0 16 16"
		>
			<path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
			<path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
		</svg>
	);
};

export const GripVertical = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-grip-vertical"
			viewBox="0 0 16 16"
		>
			<path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
		</svg>
	);
};

export const Eraser = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-eraser-fill"
			viewBox="0 0 16 16"
		>
			<path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z" />
		</svg>
	);
};

export const Pencil = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-pencil-fill"
			viewBox="0 0 16 16"
		>
			<path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
		</svg>
	);
};

export const UndoIcon = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
		</svg>
	);
};

export const PencilSquareIcon = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-pencil-square"
			viewBox="0 0 16 16"
		>
			<path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
			<path
				fillRule="evenodd"
				d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
			/>
		</svg>
	);
};

export const ArrowBarDownIcon = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-arrow-bar-down"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z"
			/>
		</svg>
	);
};

export const ArrowBarUpIcon = ({ width = 16, height = 16 }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="currentColor"
			className="bi bi-arrow-bar-up"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"
			/>
		</svg>
	);
};

export const LightningIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			stroke="gray"
			className="bi bi-lightning-fill"
			viewBox="0 0 16 16"
		>
			<path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5z" />
		</svg>
	);
};

export const ArrowRightIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-arrow-right"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
			/>
		</svg>
	);
};

export const ContractIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-arrows-angle-contract"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707zM15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707z"
			/>
		</svg>
	);
};

export const ExpandIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-arrows-angle-expand"
			viewBox="0 0 16 16"
		>
			<path
				fillRule="evenodd"
				d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z"
			/>
		</svg>
	);
};

export const XIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 384 512">
			<path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
		</svg>
	);
};

export const CopyIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 384 512">
			<path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
		</svg>
	);
};

export const DownArrowIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 384 512">
			<path d="M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z" />
		</svg>
	);
};

export const ShareIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 576 512">
			<path d="M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z" />
		</svg>
	);
};

export const DiffIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-file-diff"
			viewBox="0 0 16 16"
		>
			<path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4zm-2.5 6.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z" />
			<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
		</svg>
	);
};

export const PaperClipIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-file-diff"
			viewBox="0 0 448 512"
		>
			<path d="M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z" />
		</svg>
	);
};

export const BellIcon = ({ width = 16, height = 16, color = "currentColor" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill={color}
			className="bi bi-file-diff"
			viewBox="0 0 448 512"
		>
			<path d="M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z" />
		</svg>
	);
};
